import type { OrderDetailResponseDto } from "Infrastructure/Api/Api";
import { Stack } from "@mui/material";

import { OrderActionButtons } from "./Actions/OrderActionButtons";
import { AgentCard } from "./Cards/AgentCard";
import { ClientInfoCard } from "./Cards/ClientInfoCard";
import { DatesCard } from "./Cards/DatesCard";
import { GeneralInfoCard } from "./Cards/GeneralInfoCard";
import { PartnerInfoTile } from "./Cards/PartnerInfoTile";

type OrderHeaderProps = {
	order?: OrderDetailResponseDto;
};

export function OrderHeader({ order }: OrderHeaderProps) {
	const isAgentStatus = order?.followUpAgentStatus;

	return (
		<Stack
			direction={{ xs: "column", sm: "row" }}
			justifyContent="space-between"
			alignItems={{ xs: "stretch", sm: "center" }}
			gap={2}
			p={2}
			sx={{
				borderBottom: 1,
				borderColor: "divider",
				backgroundColor: "background.paper",
			}}
		>
			{/* Information Cards */}
			<Stack
				direction={{ xs: "column", sm: "row" }}
				gap={2}
				alignItems={{ xs: "stretch", sm: "flex-start" }}
				flexWrap="wrap"
				flex={1}
			>
				<GeneralInfoCard order={order} />
				<DatesCard order={order} />
				<ClientInfoCard order={order} />
				<PartnerInfoTile order={order} />
				{isAgentStatus && <AgentCard order={order} />}
			</Stack>

			{/* Action Buttons */}
			<OrderActionButtons order={order} />
		</Stack>
	);
}
